/** Канонические входы в новую и прежнюю версии интерфейса FrogStat. */
export const HOME_PATH = "/";
export const LEGACY_HOME_PATH = "/v1";
export const ADMIN_PATH = "/admin";
export const LEGACY_ADMIN_PATH = "/v1/admin";
